import PropTypes from 'prop-types';
import React from 'react';

export default class ModalHeader extends React.Component {
  static propTypes = {
    children: PropTypes.node
  };

  render() {
    return (
      <div className='ui top fixed huge menu borderless'>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Modules/MobileModal/Header.js